module.exports = __webpack_public_path__ + "img/logo-fisai.fce9c733.png";